import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import CircularProgress from '@material-ui/core/CircularProgress'

import DropDown from '../../common/DropDown'

import * as configActions from '../../actions/Config'
import * as laundryRulesActions from '../../actions/LaundryRules'
import * as Strings from './strings'

class EditMaxBookingsModal extends Component {
  state = {
    maxBookings: 1,
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, laundryRules, data } = this.props

    if (
      nextProps.config.editMaxBookingsModal.show &&
      !config.editMaxBookingsModal.show
    ) {
      this.setState({
        maxBookings: data.laundrySystem.laundryRule.maxBookings,
        errorMessage: ''
      })
    }

    if (
      !nextProps.laundryRules.isUpdating &&
      nextProps.laundryRules.errorUpdating === null &&
      laundryRules.isUpdating
    ) {
      this.props.hideEditMaxBookingsModal()
      this.props.showSnackbar(Strings.default.SETTING_UPDATED)
    } else if (
      !nextProps.laundryRules.isUpdating &&
      nextProps.laundryRules.errorUpdating !== null &&
      laundryRules.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  render() {
    const { maxBookings, errorMessage } = this.state
    const { config, classes, laundryRules, user, data } = this.props

    return (
      <Dialog
        open={config.editMaxBookingsModal.show}
        aria-labelledby={'form-dialog-title'}
      >
        <DialogTitle id={'form-dialog-title'}>
          {Strings.default.MAX_BOOKINGS}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Strings.default.MAX_BOOKINGS_INFO}
          </DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <DropDown
            placeholder={Strings.default.MAX_BOOKINGS}
            options={[
              { value: 1, placeholder: '1 tvättid åt gången' },
              { value: 2, placeholder: '2 tvättider åt gången' },
              { value: 3, placeholder: '3 tvättider åt gången' },
              { value: 4, placeholder: '4 tvättider åt gången' },
              { value: 5, placeholder: '5 tvättider åt gången' },
              { value: 6, placeholder: '6 tvättider åt gången' },
              { value: 7, placeholder: '7 tvättider åt gången' },
              { value: 8, placeholder: '8 tvättider åt gången' },
              { value: 0, placeholder: 'Ingen gräns' }
            ]}
            value={maxBookings}
            onChange={value => this.setState({ maxBookings: value })}
          />
        </DialogContent>
        {laundryRules.isUpdating ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => this.props.hideEditMaxBookingsModal()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => {
                const postData = { maxBookings }
                this.props.tryUpdateLaundryRules(
                  user.token,
                  data.community.id,
                  data.laundrySystem.laundryRule.id,
                  postData
                )
              }}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

function mapStateToProps({ data, user, config, laundryRules }) {
  return { data, user, config, laundryRules }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryRulesActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(EditMaxBookingsModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditMaxBookingsModal/index.js